import { api, KeepoTemplate, KeepoTemplateSummary } from "../api";

// Contents already loaded (by template and language): clicking back and forth between thumbnails
// doesn't fetch them again
const contents = new Map<string, Promise<KeepoTemplate>>();

/** The API's languages: English, or Portuguese for anything else */
const apiLanguage = (language: string) => (language.toLowerCase().startsWith("en") ? "en" : "pt");

// The template a Keepo being created was filled with (kept for the browser session), so coming back to
// the templates step shows it picked, with the Keepo as it is now, instead of applying it again
const appliedKey = (siteId: string) => `${siteId}:applied-template`;

export const templatesService = {
  getApplied(siteId: string): string | undefined {
    try {
      return sessionStorage.getItem(appliedKey(siteId)) || undefined;
    } catch {
      return undefined;
    }
  },

  setApplied(siteId: string, templateId: string) {
    try {
      sessionStorage.setItem(appliedKey(siteId), templateId);
    } catch {
      // Without storage, coming back simply shows no template picked
    }
  },

  /** The list in the app's language: English thumbnails when it's English */
  list(segment: string, specialty: string | undefined, language: string): Promise<KeepoTemplateSummary[]> {
    return api.getTemplates(segment, specialty || undefined, apiLanguage(language));
  },

  get(id: string, language: string): Promise<KeepoTemplate> {
    const lang = apiLanguage(language);
    const key = `${id}:${lang}`;
    if (!contents.has(key)) {
      contents.set(
        key,
        api.getTemplate(id, lang).catch(error => {
          contents.delete(key);
          throw error;
        })
      );
    }
    return contents.get(key) as Promise<KeepoTemplate>;
  },
};
